// removed by extract-text-webpack-plugin
module.exports = {"submitBtn":"_2WcwJOkwZ3OaJpxG9g-Evv","spinner":"_1iBaqH3ov8YbKeqq-3FSM_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMSubmitButton/OMSubmitButton.scss
// module id = 1674
// module chunks = 0